<template>
  <transition name="overlay">
    <div v-show="showOverlay"
         class="overlay"
         @click.prevent="closeByOverlay">
      <div class="modal">
        <transition :name="transition">
          <div class="card-y"
               v-show="shouldShow">
            <div class="card-other">
              <slot></slot>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="header"
               v-show="shouldShow"
               v-if="!disableCloseBtn">
            <button class="close"
                    @click="close"></button>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      showOverlay: false,
      shouldShow: false
    }
  },
  methods: {
    close () {
      this.$emit('update:show', false)
    },
    closeByOverlay (e) {
      if (this.overlayClickDisable || this.disableCloseBtn) {
        return false
      }
      if (e.currentTarget === e.target) {
        this.$emit('update:show', false)
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.show) {
      this.shouldShow = true
      this.showOverlay = true
    }
  },
  watch: {
    show (n, o) {
      if (!n && o) {
        this.close()
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          setTimeout(() => {
            this.$emit('close')
          }, 300)
          this.showOverlay = false
        }, 400)
      }
      if (n) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showOverlay = true
      }
      this.shouldShow = n
    }
  },
  props: {
    transition: {
      type: String,
      default () {
        return 'modal'
      }
    },
    disableCloseBtn: {
      type: Boolean,
      default () {
        return false
      }
    },
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    overlayClickDisable: {
      type: Boolean,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #00000099;
  width: 100vw;
  height: 100vh;
  .modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 90vw;
    .header {
      .close {
        display: block;
        border: none;
        background-color: transparent;
        background-image: url("./../../assets/modal/close.png");
        background-size: 100%;
        width: 64px;
        height: 64px;
        margin: 10px auto;
      }
    }
  }
}
.overlay-enter-active {
  transition: opacity 0.3s;
  opacity: 1;
}
.overlay-leave-active {
  transition: opacity 0.3s;
  opacity: 1;
}
.overlay-enter,
.overlay-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.4s ease;
}
.scale-enter,
.scale-leave-to {
  transform: translateY(1rem) scale(0);
  opacity: 0;
}

.modal-enter-active {
  animation: modal-animation-y 0.5s cubic-bezier(0.62, 1.89, 0.62, 0.94);
  .card-other {
    animation: modal-animation-other 0.5s cubic-bezier(0, 0, 0.33, 1);
  }
}
.modal-leave-active {
  animation: modal-animation-y-leave 0.4s cubic-bezier(0.38, 0.06, 0.38, -0.89);
  .card-other {
    animation: modal-animation-other-leave 0.4s cubic-bezier(0.67, 0, 1, 1);
  }
}
.card-y {
  perspective: 10rem;
}
@keyframes modal-animation-y {
  0% {
    transform: translateY(100vw);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes modal-animation-y-leave {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100vw);
  }
}
@keyframes modal-animation-other {
  0% {
    transform: scale(0) rotate3d(3, 0, 0, -20deg);
    opacity: 0;
  }
  100% {
    transform: scale(1) rotate3d(3, 0, 0, 0deg);
    opacity: 1;
  }
}
@keyframes modal-animation-other-leave {
  0% {
    transform: scale(1) rotate3d(3, 0, 0, 0deg);
    opacity: 1;
  }
  100% {
    transform: scale(0) rotate3d(3, 0, 0, -20deg);
    opacity: 0;
  }
}
</style>
